import { getPmSection } from 'services/pm-section/actions'

export function fetchSection (sectionId) {
  return getPmSection({ sectionId })
}

export default fetchSection
